<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra">
    <div class="row  ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Integrasi</span> - e-CKHT</p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila masukkan TIN, Tahun Pelupusan dan tekan butang Hantar</p>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-1 ms-5">
        <label>TIN : </label>
      </div>
      <div class="col-2 ms-2">
        <input type="number" [(ngModel)]="TINInput" [ngModelOptions]="{standalone: true}" class="form-control border-0 shadow">
      </div>
      <div class="col-4">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(TINInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2 bg-white" role="button" (click)="Semula()">Semula</button>
          </div>
        </div>
      </div>
    </div>

    <div class="accordion px-5 pb-5" id="resultAcordion" *ngIf="SearchStatus">
      <div class="accordion-item border-0">
        <h2 class="accordion-header m-0" id="headingOne">
          <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Butiran Carian
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
          <div class="accordion-body">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-5">
                <p><strong>{{TaxpNameView}}</strong></p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-1">
                <p><strong>{{TINView}}</strong></p>
              </div>
            </div>

            <div class="pt-4">
              <p class="fw-bold">Ejen cukai yang mengemukakan e-CKHT bagi pihak pembayar cukai perlu memastikan borang <a href="https://www.hasil.gov.my/media/ye3kzp5i/ckht-57a-surat-kuasa-lantikan-peguam.pdf" target="_blank">CP57A</a> lengkap diisi. HASiL berhak pada bila-bila masa mendapatkan borang berkenaan.</p>
            </div>

            <div class="pt-2">
              <p>Senarai Borang</p>
              <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
            </div>
            <div>
              <table class="table w-100 shadow">
                <thead>
                  <tr class="primary-colour text-center">
                    <th scope="col">Jenis Borang</th>
                    <th scope="col">Ejen Cukai</th>
                    <th scope="col">Tindakan</th>
                  </tr>
                </thead>
                <tbody class="bg-white text-center">
                  <tr>
                    <td>e-CKHT</td>
                    <td>
                      <div>
                        <select class="form-select border-0 shadow" [(ngModel)]="AgentInput" [ngModelOptions]="{standalone: true}">
                          <option value="">Ejen Cukai</option>
                          <option *ngFor="let res of AgentList" [value]="res.taxAgentID">{{res.taxAgentName}}</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div class="row d-flex justify-content-center">
                        <div class="col-auto">
                          <div class="btn-toolbar">
                            <div class="me-2">
                              <button type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="Login(TINView,AgentInput)">Login / Semakan</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
